import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { PageFrame } from "../../components/page_frame";
import { useCustomer } from "../../contexts/app/provider";

export const ProfilePage = () => {
  const { whoIAm: user } = useCustomer();

  return (
    <PageFrame>
      <Box sx={{ p: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <Typography variant="h1">Profile</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 2, sm: 10 },
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Typography>
              <b>Name:</b> {user?.name}
            </Typography>
            <Typography>
              <b>Email:</b> {user?.email}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Typography>
              <b>Role:</b> {user?.role}
            </Typography>
            <Typography>
              <b>CustomerId:</b> {user?.customerId}
            </Typography>
          </Box>
        </Box>
      </Box>
    </PageFrame>
  );
};
